import { useEffect, useRef, useState } from "react";

export function useTextTruncation<T extends HTMLElement = HTMLElement>(
  dependencies: any[] = [],
) {
  const ref = useRef<T>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const checkTruncation = () => {
      setIsTruncated(element.scrollHeight > element.clientHeight);
    };

    const resizeObserver = new ResizeObserver(checkTruncation);
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, dependencies);

  return { ref, isTruncated };
}
